export default __webpack_public_path__ + "static/media/Gesture icons_Tap-17.16fa33df.svg";